import React from "react";

const OverviewEJ = () => {
  return (
    <div className="flex md:space-x-2">
      <div className="md:w-3/4">
        <div className="border-2 p-2 border-sdorange inline-block mb-1 ">
          <p>Course Overview</p>
        </div>
        <div>
          <img src="/image-fix/random-images/emerging-journalist.jpg" />
        </div>
        <div id="overview">
          <p className="text-justify">
            The Emerging Journalist Programme is a comprehensive postgraduate
            certificate designed to prepare aspiring journalists for the dynamic
            and evolving media industry. This 30-ECTS course combines
            theoretical insights with practical skills, enabling participants to
            master advanced news writing, investigative reporting, multimedia
            storytelling, and ethical journalism. Students will critically
            analyse the media landscape, explore emerging trends, and leverage
            technological advancements to produce impactful stories. With a
            strong emphasis on collaboration, innovation, and professional
            ethics, graduates will be equipped to excel in diverse media roles,
            contribute to meaningful storytelling, and adapt to the
            ever-changing demands of global journalism.
          </p>
        </div>

      </div>
      <div className="md:w-1/4 hidden p-2 rounded-lg border-2 border-sdorange bg-sdbodywhiteywhitebody md:flex items-center">
        {" "}
        <img
          src="/image-fix/academic-programmes/executive-education/schima.png"
          className="w- w-full"
        />
      </div>
    </div>
  );
};

export default OverviewEJ;
